import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../services/firebase/config";
import { COLLECTIONS } from "../constants/paymentConstants";

/**
 * Fetches all orders from Firestore
 * @returns {Promise<Array>} array of order objects with id
 */
export const fetchAllOrders = async () => {
	const snapshot = await getDocs(collection(db, COLLECTIONS.ORDERS));
	return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

/**
 * Fetches all payments from Firestore
 * @returns {Promise<Object>} map of paymentId => paymentObject
 */
export const fetchAllPayments = async () => {
	const snapshot = await getDocs(collection(db, COLLECTIONS.PAYMENTS));
	const paymentsMap = {};
	snapshot.docs.forEach((doc) => {
		paymentsMap[doc.id] = { id: doc.id, ...doc.data() };
	});
	return paymentsMap;
};
